import React, { useCallback, useContext, useRef, useState } from 'react'
import { Col, Row, Card, Form, InputGroup, Button, Spinner } from '@themesberg/react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt, faSearch, faFilter, faFileExcel } from '@fortawesome/free-solid-svg-icons'
import Datetime from "react-datetime";
import moment from "moment-timezone";
import { Context } from '../Reward'
import { useCookies } from 'react-cookie'
import { exportAllReward } from '../../../../controller/api/__classic__/reward'
import { exportClassicRewardToExcel } from '../../../../helpers/excelExport'

const _FilterForm = ({ region }) => {

  const { state, dispatch } = useContext(Context);
  const [cookies] = useCookies(['lottmekong']);

  const _from = useRef(state.filter.from);
  const _to = useRef(state.filter.to);
  const _phone = useRef(state.filter.phone);

  const [isExporting, setIsExporting] = useState(false);

  const _handleChangeFrom = useCallback((payload) => {
    _from.current = payload
  }, [])

  const _handleChangeTo = useCallback((payload) => {
    _to.current = payload
  }, [])

  const _handleChangePhone = useCallback((payload) => {
    _phone.current = payload.target.value
  }, [])

  const _submitForm = useCallback(() => {
    dispatch({
      type: 'SUBMIT_FILTER',
      payload: {
        from: _from.current,
        to: _to.current,
        phone: _phone.current
      }
    })
  }, [dispatch])

  const handleExportExcel = async () => {
    setIsExporting(true);
    try {
      let phone = state.filter.phone || '';
      if (phone.indexOf('MB') < 0 && phone.startsWith('0')) {
        phone = phone.replace('0', '+84');
      }

      const query = {
        from: state.filter.from,
        to: state.filter.to,
        phone: phone,
        region: region
      };

      const response = await exportAllReward(cookies.lottmekong, query);
      if (response && response.data) {
        exportClassicRewardToExcel(response.data, state.filter, region);
      }
    } catch (error) {
      console.error('Export failed:', error);
      alert('Xuất Excel thất bại. Vui lòng thử lại!');
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <>
      <Card border="light" className="shadow-sm border-0">
        <Card.Body className="p-3">
          <div className="d-flex align-items-center mb-3">
            <div className="icon icon-shape icon-sm shadow-sm border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
              <FontAwesomeIcon icon={faFilter} className="text-primary" />
            </div>
            <h6 className="mb-0">{region === 'MN' ? 'Trúng thưởng Miền Nam' : 'Trúng thưởng Miền Trung'}</h6>
          </div>

          <Row className="g-3 align-items-end">
            <Col xs={12} md={6} xl={4}>
              <Form.Label className="small fw-bold text-uppercase text-muted mb-2">Từ ngày</Form.Label>
              <Datetime
                timeFormat={false}
                onChange={_handleChangeFrom}
                renderInput={(props, openCalendar) => (
                  <InputGroup className="input-group-merge">
                    <InputGroup.Text className="bg-white border-end-0">
                      <FontAwesomeIcon icon={faCalendarAlt} className="text-muted" />
                    </InputGroup.Text>
                    <Form.Control
                      required
                      type="text"
                      className="border-start-0 ps-0"
                      value={_from.current ? moment(_from.current).format("DD/MM/YYYY") : ""}
                      placeholder="dd/mm/yyyy"
                      onFocus={openCalendar}
                      onChange={() => { }}
                    />
                  </InputGroup>
                )}
              />
            </Col>

            <Col xs={12} md={6} xl={4}>
              <Form.Label className="small fw-bold text-uppercase text-muted mb-2">Đến ngày</Form.Label>
              <Datetime
                timeFormat={false}
                onChange={_handleChangeTo}
                renderInput={(props, openCalendar) => (
                  <InputGroup className="input-group-merge">
                    <InputGroup.Text className="bg-white border-end-0">
                      <FontAwesomeIcon icon={faCalendarAlt} className="text-muted" />
                    </InputGroup.Text>
                    <Form.Control
                      required
                      type="text"
                      className="border-start-0 ps-0"
                      value={_to.current ? moment(_to.current).format("DD/MM/YYYY") : ""}
                      placeholder="dd/mm/yyyy"
                      onFocus={openCalendar}
                      onChange={() => { }}
                    />
                  </InputGroup>
                )}
              />
            </Col>

            <Col xs={12} md={6} xl={4}>
              <Form.Label className="small fw-bold text-uppercase text-muted mb-2">Điện thoại</Form.Label>
              <Form.Control
                onChange={_handleChangePhone}
                type="text"
                placeholder="Nhập số điện thoại"
                className="bg-white"
                onKeyDown={(e) => {
                    if (e.key === "Enter") _submitForm();
                }}
              />
            </Col>
          </Row>

          <Row className="mt-3">
            <Col xs={12} className="d-flex justify-content-end gap-2">
              <Button
                variant="primary"
                onClick={_submitForm}
                className="shadow-sm"
                disabled={state.isLoading}
              >
                {state.isLoading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Đang tải...
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faSearch} className="me-2" />
                    Tìm kiếm
                  </>
                )}
              </Button>
              <Button
                variant="success"
                type="button"
                className="shadow-sm"
                disabled={isExporting || state.isLoading}
                onClick={handleExportExcel}
              >
                {isExporting ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Đang xuất...
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faFileExcel} className="me-2" />
                    Xuất Excel
                  </>
                )}
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

export default React.memo(_FilterForm)
